import React from 'react';
import {BENEFIT} from '../../constants';
import './benefit.css';
import graph from './graph.svg';
import time from './time.svg';
import like from './like.svg';

const icons = {'graph': graph, 'time': time, 'like': like};

const Benefit = () => {
	return (
		<div className="benefit">
			<div className="benefit__inner">
				{BENEFIT.map((item) => {
					return (
						<div className="benefit__item" key={"benefit" + item.svgIcon}>
							<div className="benefit__icon-wrap">
								<img src={icons[item.svgIcon]} className={"benefit__icon benefit__icon--" + item.svgIcon}
								     alt="benefit icon"/>
							</div>
							<div className="benefit__info">
								<h3 className="benefit__title">{item.title}</h3>
								<div className="benefit__text">
									{item.textBegin}
									{item.textSecond && <br/>}
									<span className='benefit__highlight'>{item.textHighlight}</span>
									{item.otherText}
								</div>
							</div>
						</div>)
				})}
			</div>
		</div>
	);
};

export default Benefit;



// WEBPACK FOOTER //
// ./src/components/Benefit/Benefit.js